// KPIs › My numbers (`/c/{slug}/kpis/my-numbers?tab=`; UX-A, ux pass 1.3: one "Mine" page): the
// numbers the person enters (tab "numbers", the default) and their own seats' scorecard (tab
// "scorecard", which was `/kpis/my-scorecard`; that URL redirects here).
import { PageHeader, ViewTabs } from "@companyos/ui";
import { useQuery } from "@tanstack/react-query";
import { GaugeIcon, HashIcon } from "lucide-react";
import type { Api } from "../../api/client";
import type { CompanyAccess } from "../company";
import { myNumbersQuery } from "../queries";
import { MyNumbersScreen } from "./my-numbers";
import { outstanding } from "./my-numbers-model";
import { MyScorecardScreen } from "./my-scorecard";

export const MY_NUMBERS_TABS = ["numbers", "scorecard"] as const;
export type MyNumbersTab = (typeof MY_NUMBERS_TABS)[number];

export function MyNumbersPage({
  api,
  company,
  tab,
  onTab,
}: {
  api: Api;
  company: CompanyAccess;
  tab: MyNumbersTab;
  onTab: (tab: MyNumbersTab) => void;
}) {
  // Shared cached read with both tabs and the sidebar row.
  const numbers = useQuery(myNumbersQuery(api, company.id));
  const due = outstanding(numbers.data).length;
  return (
    <div className="flex flex-col">
      <PageHeader title="My numbers" spacing="tabs" />
      <ViewTabs
        aria-label="My numbers views"
        value={tab}
        onValueChange={(v) => onTab(v as MyNumbersTab)}
        tabs={[
          { value: "numbers", label: "Enter", icon: HashIcon, ...(due ? { count: due } : {}) },
          { value: "scorecard", label: "My scorecard", icon: GaugeIcon },
        ]}
      />
      <div className="pt-4">
        {tab === "scorecard" ? (
          <MyScorecardScreen api={api} company={company} />
        ) : (
          <MyNumbersScreen api={api} company={company} />
        )}
      </div>
    </div>
  );
}
